import React, { Component } from 'react';
import { Route, Redirect } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../actions/LoginActions";

class PrivateRoute extends Component {

    constructor(props) {
        super(props);
        props.checkLogin();

        this.focusHandler = this.focusHandler.bind(this);
        window.addEventListener("focus", this.focusHandler, false);
    }

    focusHandler(e) {
        this.props.checkLogin();
    }

    render() {
         
        let props = {};
        if (typeof this.props.component === "function") {
            props.component = this.props.component;
        } else {
            props.render = () => this.props.component;
        }
        return this.props.isAuth
            ? <Route path={this.props.path} component={this.props.component} />
            : <Redirect from={this.props.path} to="/login" />;
    }

    componentWillUnmount() {
        window.removeEventListener("focus", this.focusHandler, false);
    }
}

export default connect(
    state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(PrivateRoute);


// WEBPACK FOOTER //
// ./src/common/PrivateRoute.js